import axios from "axios";
import { supabase } from "./supabaseClient";

const getApiUrl = () => {
  return (
    window.ENV?.REACT_APP_API_URL ||
    process.env.REACT_APP_API_URL ||
    "/api"
  );
};

const API_URL = getApiUrl();

const axiosInstance = axios.create({
  baseURL: API_URL,
});

export const dashboardService = {
  async getMonthlyProductionTotal(filters = {}) {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error("Usuário não autenticado.");
      }

      const response = await axiosInstance.get(`/production/total-monthly-production`, {
        headers: { Authorization: `Bearer ${token}` },
        params: filters,
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data.message || "Erro ao buscar produção mensal");
      }
      throw error;
    }
  },

  async getMonthlyExpeditionTotal(filters = {}) {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error("Usuário não autenticado.");
      }

      const response = await axiosInstance.get(`/expeditions/total-monthly-expedition`, {
        headers: { Authorization: `Bearer ${token}` },
        params: filters,
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data.message || "Erro ao buscar expedição mensal");
      }
      throw error;
    }
  },

  // Buscar sugestões de produção
  async getProductionSuggestions() {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error("Usuário não autenticado.");
      }

      const response = await axiosInstance.get(`/production/suggestions`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Retornar o objeto completo da resposta (com cache_info, etc)
      const result = response.data;
      return result; // Retorna { success, suggestions, count, cache_info, ... }
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data.message || "Erro ao buscar sugestões de produção");
      }
      throw error;
    }
  },

  // Buscar alertas de stock
  async getStockAlerts() {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error("Usuário não autenticado.");
      }

      const response = await axiosInstance.get(`/stock/alerts`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Garantir que retorna um array
      const result = response.data;
      if (Array.isArray(result)) {
        return result;
      } else if (result?.data && Array.isArray(result.data)) {
        return result.data;
      } else {
        return [];
      }
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data.message || "Erro ao buscar alertas de stock");
      }
      throw error;
    }
  },

  // Buscar produtos prontos
  async getReadyProducts() {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error("Usuário não autenticado.");
      }

      const response = await axiosInstance.get(`/stock/ready-products`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Garantir que retorna um array
      const result = response.data;
      if (Array.isArray(result)) {
        return result;
      } else if (result?.data && Array.isArray(result.data)) {
        return result.data;
      } else {
        return [];
      }
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data.message || "Erro ao buscar produtos prontos");
      }
      throw error;
    }
  },
};
